var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Dialog',{attrs:{"title":"你確定要重設密碼嗎?","isVisible":true,"loading":_vm.loading},on:{"ok":_vm.ok,"cancel":_vm.back}})
}
var staticRenderFns = []

export { render, staticRenderFns }